function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 19.6078C7.5 19.6078 15 13.1336 15 6.84425C15 3.06427 11.6421 0 7.5 0C3.35786 0 0 3.06427 0 6.84425C0 13.1336 7.5 19.6078 7.5 19.6078ZM7.5 10.7059C9.433 10.7059 11 9.13887 11 7.20587C11 5.27287 9.433 3.70587 7.5 3.70587C5.567 3.70587 4 5.27287 4 7.20587C4 9.13887 5.567 10.7059 7.5 10.7059Z"
});

var SvgMarkerSmallIcon = function SvgMarkerSmallIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    "aria-hidden": "true",
    role: "presentation",
    "aria-label": "marker",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarkerSmallIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker-small-icon.e4e4c430.svg";
export { ForwardRef as ReactComponent };